import "./contact.css"
import React, {useState, useEffect} from "react"
import validation from "./validation"
import { collection, addDoc } from "firebase/firestore"; 
import { db } from "../firebase"
import { FaInstagram, FaGithub, FaDev, FaLinkedin } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Contact = () => {
    
        const [values, setValues] = useState({
            name:"",
            email:"",
            message:""
        });
        const handleChange = (e) =>{
            setValues({
                ...values,
                [e.target.name] : e.target.value,
            });

        }
        const [errors, setErrors] = useState({});
        const [valid, setValid] = useState(false);

        const formSubmit = (e) =>{
            e.preventDefault();
            setErrors(validation(values));
            setValid(true);
        }

        useEffect(() => {
            async function addData(val){
                    try {
                      // eslint-disable-next-line
                      const docRef = await addDoc(collection(db, "ContMsgs"), {
                        name: val.name,
                        email: val.email,
                        message: val.message,
                      });

                      const discord = {
                        content: `You got a new Message from ${val.name}`,
                        embeds: [
                          {
                            title: val.email,
                            description: `${val.message} `,
                          },
                        ],
                      };

                      fetch(
                        "https://discord.com/api/webhooks/938120490013315094/SAp95bvb6odGUGP5C1Ze6xnjsJi6ZYK7TiLqHC24v62Qr11mJdL62K74OiIc3EB4rtjZ",
                        {
                          method: "POST",
                          headers: { "content-type": "application/json" },
                          body: JSON.stringify(discord),
                        }
                      );

                      toast.success("Message Sent.", {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                      });

                      // toast.info('Message id: '+ docRef.id, {
                      //     position: "top-center",
                      //     autoClose: 7000,
                      //     hideProgressBar: false,
                      //     closeOnClick: true,
                      //     pauseOnHover: true,
                      //     draggable: true,
                      //     progress: undefined,
                      // })
                    }
                    catch(err){
                        toast.error('Message failed to Sent.', {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        })
                        
                         const discordErr = {
                            "content": `${val.name} failed to send a message.`,
                            "embeds": [{
                                "title": val.email,
                                "description": `${val.message} /n ${err}`,
                            }]
                            };
                        
                        fetch("https://discord.com/api/webhooks/938120490013315094/SAp95bvb6odGUGP5C1Ze6xnjsJi6ZYK7TiLqHC24v62Qr11mJdL62K74OiIc3EB4rtjZ", {
                            method: "POST",
                            headers: {"content-type": "application/json"},
                            "body": JSON.stringify(discordErr)
                        })

                        // toast.info('Error: '+err.message, {
                        //     position: "top-center",
                        //     autoClose: 5000,
                        //     hideProgressBar: false,
                        //     closeOnClick: true,
                        //     pauseOnHover: true,
                        //     draggable: true,
                        //     progress: undefined,
                        // })

                    }
                };

            if(Object.keys(errors).length === 0 && valid){
                addData(values)
                // db.collection('ContactMsg').add({
                //     name : values.name,
                //     email : values.email,
                //     message : values.message
                // })
                setValues({name:"",email:"",message:""})
                setValid(false);

            }
        }, [errors,valid,values]);

        return(
            <div id="contact">
                <h1 className="section-head">Contact Me</h1>
                <ToastContainer />
                <div className="contact_wrapper">
                    <div className="contact_info">

                        <ul className="icons_wrapp">
                        <li>
                            <div className="icon">
                            <span className="material-icons-outlined"> mail_outline </span>
                            </div>
                            <div className="text">
                                <a href="mailto:areeburrub@gmail.com" target="_blank" without rel="noreferrer">areeburrub@gmail.com</a>
                            </div>
                        </li>
                        <li>
                            <div className="icon">
                            <span className="material-icons-outlined"> phone_in_talk </span>
                            </div>
                            <div className="text">
                                <a href="tel:+919546557824" target="_blank" without rel="noreferrer">+91 9546557824</a>
                            </div>
                        </li>
                        <li>
                            <div className="icon">
                            <span className="material-icons-outlined"><FaLinkedin /></span>
                            </div>
                            <div className="text">
                                <a href="https://www.linkedin.com/in/areeburrub/" target="_blank" without rel="noreferrer">areeburrub</a>
                            </div>
                        </li>
                        <li>
                            <div className="icon">
                            <span className="material-icons-outlined"><FaDev /></span>
                            </div>
                            <div className="text">
                                <a href="https://dev.to/areeburrub" target="_blank" without rel="noreferrer">dev.to/areeburrub</a>
                            </div>
                        </li>
                        <li>
                            <div className="icon">
                            <span className="material-icons-outlined"><FaGithub /></span>
                            </div>
                            <div className="text">
                                <a href="https://github.com/areeburrub" target="_blank" without rel="noreferrer">areeburrub</a>
                            </div>
                        </li>
                        <li>
                            <div className="icon">
                            <span className="material-icons-outlined"><FaInstagram /></span>
                            </div>
                            <div className="text">
                                <a href="https://www.instagram.com/areeb.ur_rub/" target="_blank" without rel="noreferrer">areeb.ur_rub</a>
                            </div>
                        </li>
                        </ul>

                    </div>

                    <form className="contact_msg">
                        <h3 className="title">
                        Send a Message or Feedback
                        </h3>

                        <div className="form_fild">
                        <div className="input_group w_50">
                            <input type="text" className="input" required value={values.name} name="name" onChange={handleChange}/>
                            <label className="placeholder">Full Name</label>
                            {errors.name && <span className="form-error"> {errors.name}</span> }
                        </div>


                        <div className="input_group w_50">
                            <input type="text" className="input" required value={values.email} name="email" onChange={handleChange}/>
                            <label className="placeholder">Email Address</label>
                            {errors.email && <span className="form-error"> {errors.email}</span> }
                        </div>

                        <div className="input_group w_100">
                            <textarea className="input input_textarea " rows="6" required  value={values.message} name="message" onChange={handleChange}></textarea>
                            <label className="placeholder textarea">Write your message here...</label>
                            {errors.message && <span className="form-error"> {errors.message}</span> }
                        </div>

                        <div className="input_group">
                            <input type="submit" className="btn" value="Send" onClick={formSubmit}/>
                        </div>

                        </div>

                    </form>

                </div>

            </div>
        );
    }



export default Contact;
